export default "__VITE_ASSET__BSDOX5X4__"